import { useQuery } from "@tanstack/react-query";
import { AxiosRequestConfig } from "axios";
import { ApiResponse } from "../../../types/api-response";
import axios from "../../../utils/axiosInceptor";
import { apiV1Endpoint } from "../endpoints";
import { ConfigResponse } from "./types";

type GetMasterConfigOptions = Pick<AxiosRequestConfig, "params">;

type UseGetMasterConfigOptions = GetMasterConfigOptions & {
  isEnabled?: boolean;
};

const getConfig = async (options: GetMasterConfigOptions) => {
  const { params } = options;

  const url = `${apiV1Endpoint}/configData`;
  const response = await axios.get<ApiResponse<ConfigResponse[]>>(url, { params });
  return response.data.result;
};

export const useGetConfig = (options: UseGetMasterConfigOptions) => {
  const { isEnabled, ...restProps } = options;

  const { data, isLoading } = useQuery({
    queryKey: ["config", restProps?.params],
    queryFn: () => getConfig(restProps),
    enabled: isEnabled,
    staleTime: 5 * 60 * 1000, // cache for 5 minutes
    refetchOnWindowFocus: false,
  });

  return {
    config: data,
    isLoadingConfig: isLoading,
  };
};
